/**
 * Recall workspace (owner WP3-REMIND; BUILD-PLAN M12, research/library/recall.md 4.2).
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'recall',
    title: 'Recall',
    version: '0.1.0',
    owner: 'WP3-REMIND',
    entitlementKey: null,
    permissions: ['patient.view', 'patient.edit', 'comms.send', 'settings.manage', 'money.view'],
    routes: [
      {
        id: 'workspace',
        path: '/recall',
        title: 'Recall',
        permission: 'patient.view',
        officeScope: 'location-or-all',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'Recall',
        labelKey: 'recall',
        group: 'patients',
        routeId: 'workspace',
        icon: 'rotate-ccw',
        order: 40,
      },
    ],
    commands: [
      {
        id: 'recall.open',
        title: 'Go to Recall',
        keywords: ['recare', 'hygiene due', 'continuing care', 'overdue', 'reactivation'],
        routeId: 'workspace',
      },
      {
        id: 'recall.why',
        title: "Why isn't a patient on the recall list?",
        keywords: ['why not', 'excluded', 'missing from recall'],
        routeId: 'workspace',
      },
    ],
    shortcuts: [{ keys: 'g r', description: 'Go to Recall', routeId: 'workspace' }],
    phiReadPoints: ['recall.list', 'recall.patient', 'recall.why'],
  }),
  pages: {
    workspace: () => import('./RecallPage.js'),
  },
});
